import React, { useEffect, useState } from "react";
import YearCalendar from "../../shared/YearlyCalendar";
import { SlIcon,SlSelect,SlOption } from "@shoelace-style/shoelace/dist/react";
import API from "../../services/api";
import { useSelector } from "react-redux";
import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import * as XLSX from "xlsx";
import { getBrandOptions, toLakhs } from "../../utils/constants";
import ScrollContainer from "react-indiana-drag-scroll";
function PlanSummary() {
  const [downloadLoader, setDownloadLoader] = useState(false);
  const selectedYear = useSelector((state) => state.Head.selectedYear);
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const year = new Date(selectedYear).getFullYear() % 100;
  const [selectedType, setSelectedType] = useState("all");
  const getdownloadData = async () => {
    try {
      setDownloadLoader(true);

      const tableData = [
        [
          "All values are in Lakhs",
          `Jan-${year - 1} to Dec-${year - 1}`,
          `Jan-${year} to Dec-${year}`,
          "Growth %",
        ],
        ["W2N-Overall"],
        [
          "Accounts Advertised",
          data?.year_wise[0]?.[`totalWay2newsInsertionCount_${data?.year_wise[0]?.year -1}`] || 0,
          data?.year_wise[0]?.[[`totalWay2newsInsertionCount_${data?.year_wise[0]?.year}`] ]|| 0,
          calculatePercentage(
            data?.year_wise[0]?.[`totalWay2newsInsertionCount_${data?.year_wise[0]?.year -1}`],
            data?.year_wise[0]?.[[`totalWay2newsInsertionCount_${data?.year_wise[0]?.year}`] ]
          ),
        ],
        [
          "No of Insertions",
          data?.year_wise[0]?.[`totalWay2newsInsertions_${data?.year_wise[0]?.year -1}`]  || 0,
          data?.year_wise[0]?.[`totalWay2newsInsertions_${data?.year_wise[0]?.year}`]  || 0,
          calculatePercentage(
            data?.year_wise[0]?.[`totalWay2newsInsertions_${data?.year_wise[0]?.year -1}`]  || 0,
            data?.year_wise[0]?.[`totalWay2newsInsertions_${data?.year_wise[0]?.year}`]  || 0,
          ),
        ],
        [
          "Revenues",
          data?.year_wise[0]?.[`totalWay2newsRevenue_${data?.year_wise[0]?.year-1}`] || 0,
          data?.year_wise[0]?.[`totalWay2newsRevenue_${data?.year_wise[0]?.year}`] || 0,
          calculatePercentage(
            data?.year_wise[0]?.[`totalWay2newsRevenue_${data?.year_wise[0]?.year-1}`],
            data?.year_wise[0]?.[`totalWay2newsRevenue_${data?.year_wise[0]?.year}`] 
          ),
        ],
        [
          "Revenue per Insertion",
          Math.round(
            data?.year_wise[0]?.[`totalWay2newsRevenue_${data?.year_wise[0]?.year-1}`]/
            data?.year_wise[0]?.[`totalWay2newsInsertions_${data?.year_wise[0]?.year -1}`]
          ) || 0,
          Math.round(
            data?.year_wise[0]?.[`totalWay2newsRevenue_${data?.year_wise[0]?.year}`]/
            data?.year_wise[0]?.[`totalWay2newsInsertions_${data?.year_wise[0]?.year}`]
          ) || 0,
          calculatePercentage(
            data?.year_wise[0]?.[`totalWay2newsRevenue_${data?.year_wise[0]?.year-1}`]/
            data?.year_wise[0]?.[`totalWay2newsInsertions_${data?.year_wise[0]?.year -1}`] || 0,
            data?.year_wise[0]?.[`totalWay2newsRevenue_${data?.year_wise[0]?.year}`]/
            data?.year_wise[0]?.[`totalWay2newsInsertions_${data?.year_wise[0]?.year}`]
          ),
        ],
        ["W2N-Category Wise"],
      ];

      data?.category_wise?.forEach((item) => {
        if (item?.category) {
          let arr = [
            [item.category],
            [
              "Accounts Advertised",
              item?.[`totalWay2newsBrandCount_${item?.year -1}`] || 0,
              item?.[`totalWay2newsBrandCount_${item?.year}`]  || 0,
              calculatePercentage(
                item?.[`totalWay2newsBrandCount_${item?.year -1}`],
                item?.[`totalWay2newsBrandCount_${item?.year}`] 
              ),
            ],
            [
              "No of Insertions",
              item?.[`totalWay2newsInsertions_${item?.year-1}`] || 0,
              item?.[`totalWay2newsInsertions_${item?.year}`] || 0,
              calculatePercentage(
                item?.[`totalWay2newsInsertions_${item?.year-1}`] ,
                item?.[`totalWay2newsInsertions_${item?.year}`]
              ),
            ],
            [
              "Revenues",
              item?.[`totalWay2newsRevenue_${item?.year-1}`] || 0,
              item?.[`totalWay2newsRevenue_${item?.year}`] || 0,
              calculatePercentage(
                item?.[`totalWay2newsRevenue_${item?.year-1}`],
                item?.[`totalWay2newsRevenue_${item?.year}`]
              ),
            ],
            [
              "Revenue per Insertion",
              Math.round(
                item?.[`totalWay2newsRevenue_${item?.year-1}`]  / item?.[`totalWay2newsInsertions_${item?.year-1}`]
              ) || 0,
              Math.round(
                item?.[`totalWay2newsRevenue_${item?.year}`] / item?.[`totalWay2newsInsertions_${item?.year}`]
              ) || 0,
              calculatePercentage(
                item?.[`totalWay2newsRevenue_${item?.year-1}`]  /
                item?.[`totalWay2newsInsertions_${item?.year-1}`] || 0,
                item?.[`totalWay2newsRevenue_${item?.year}`] /
                item?.[`totalWay2newsInsertions_${item?.year}`] || 0
              ),
            ],
          ];
          tableData.push(...arr);
        }
      });

      // Create worksheet and workbook
      const worksheet = XLSX.utils.aoa_to_sheet(tableData);
      let merges = [];
      merges.push({ s: { r: 1, c: 0 }, e: { r: 1, c: 3 } });
      merges.push({ s: { r: 6, c: 0 }, e: { r: 6, c: 3 } });
      let row_index = 7;
      data?.category_wise?.forEach((item, index) => {
        if (item?.category) {
          merges.push({
            s: { r: row_index, c: 0 },
            e: { r: row_index, c: 3 },
          });
          row_index += 5;
        }
      });

      worksheet["!merges"] = merges;
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "PlanSummary");

      // Write the Excel file and trigger download
      XLSX.writeFile(workbook, `PlanSummary_${year}.xlsx`);
    } catch (error) {
      console.error("Error downloading Excel file:", error);
    } finally {
      setDownloadLoader(false);
    }
  };

  const fetchData = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "plansummary/get",
        method: "POST",
        responseType: "json",
        data: {
          year: selectedYear,
          type:selectedType
        },
      });
      if (res.code === 200) {
        setData(res.data);
        if(res.data.userType !== -1){
          setSelectedType(`${res.data.userType}`)
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const calculatePercentage = (previous, current) => {
    if (previous === 0) {
      return current === 0 ? "No growth" : "Infinity %";
    }
    const growth = ((current - previous) / previous) * 100;
    return `${growth.toFixed(2)} %`;
  };

  const getRecord = (category) => {
    try {
      return data?.category_wise?.filter((item) => item.category === category);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [selectedYear,selectedType]);

  return (
    <>
      <div className="d-flex gap-3 justify-end items-center my-2">
      <SlSelect size="small" value={selectedType} label="Team"  onSlChange={(e) => {setSelectedType(e.target.value)}}>
      {data?.userType === -1 ? <SlOption value='all'>All</SlOption> : null}
          {getBrandOptions(data?.userType, localStorage.getItem('email'))?.map((type) => (
            <SlOption key={type.value} value={type.value}>{type.label}</SlOption>
          ))}
        </SlSelect>
        <YearCalendar startYear={2023} endYear={2100}></YearCalendar>
        {downloadLoader ? (
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        ) : (
          <div
            className="w-7 h-7 bg-slate-100 hover:text-cyan-500 rounded-lg cursor-pointer items-center justify-center hover:bg-slate-150 flex"
            onClick={getdownloadData}
          >
            <sl-tooltip content="Download" placement="top">
              <SlIcon library="lucide" name="download" />
            </sl-tooltip>
          </div>
        )}
      </div>
      <ScrollContainer>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>All values are in Lakhs</th>
            <th>
              Jan-{`${year - 1}`} to Dec-{`${year - 1}`}
            </th>
            <th>
              Jan-{`${year}`} to Dec-{`${year}`}
            </th>
            <th>Growth %</th>
          </tr>
        </thead>
        {!loader && Object.keys(data)?.length > 0 ? (
          <tbody>
            <tr>
              <td colSpan={7} className="font-semibold">
                W2N-overall
              </td>
            </tr>

            <tr>
              <td>Accounts Advertised</td>
              <td>{data?.year_wise[0]?.[`totalWay2newsInsertionCount_${data?.year_wise[0]?.year -1}`]}</td>
              <td>{data?.year_wise[0]?.[`totalWay2newsInsertionCount_${data?.year_wise[0]?.year}`]}</td>
              <td>
                {calculatePercentage(
                  data?.year_wise[0]?.[`totalWay2newsInsertionCount_${data?.year_wise[0]?.year -1}`],
                  data?.year_wise[0]?.[`totalWay2newsInsertionCount_${data?.year_wise[0]?.year}`]
                )}
              </td>
            </tr>
            <tr>
              <td>No of Insertions</td>
              <td>{data?.year_wise[0]?.[`totalWay2newsInsertions_${data?.year_wise[0]?.year-1}`]}</td>
              <td>{data?.year_wise[0]?.[`totalWay2newsInsertions_${data?.year_wise[0]?.year}`]}</td>
              <td>
                {calculatePercentage(
                  data?.year_wise[0]?.[`totalWay2newsInsertions_${data?.year_wise[0]?.year-1}`],
                  data?.year_wise[0]?.[`totalWay2newsInsertions_${data?.year_wise[0]?.year}`]
                )}
              </td>
            </tr>
            <tr>
              <td>Revenues</td>
              <td>{toLakhs(data?.year_wise[0]?.[`totalWay2newsRevenue_${data?.year_wise[0]?.year - 1}`])}</td>
              <td>{toLakhs(data?.year_wise[0]?.[`totalWay2newsRevenue_${data?.year_wise[0]?.year}`])}</td>
              <td>
                {calculatePercentage(
                  data?.year_wise[0]?.[`totalWay2newsRevenue_${data?.year_wise[0]?.year-1}`],
                  data?.year_wise[0]?.[`totalWay2newsRevenue_${data?.year_wise[0]?.year}`]
                )}
              </td>
            </tr>
            <tr>
              <td>Revenue per Insertion</td>
              <td>
                { data?.year_wise[0]?.[`totalWay2newsInsertions_${data?.year_wise[0]?.year-1}`] ?
                  toLakhs(data?.year_wise[0]?.[`totalWay2newsRevenue_${data?.year_wise[0]?.year-1}`] /
                    data?.year_wise[0]?.[`totalWay2newsInsertions_${data?.year_wise[0]?.year-1}`] || 0 ): 0
                }
              </td>
              <td>
                { data?.year_wise[0]?.[`totalWay2newsInsertions_${data?.year_wise[0]?.year}`]? toLakhs(
                  data?.year_wise[0]?.[`totalWay2newsRevenue_${data?.year_wise[0]?.year}`] /
                  data?.year_wise[0]?.[`totalWay2newsInsertions_${data?.year_wise[0]?.year}`] || 0
                ) : 0}
              </td>
              <td>
                {calculatePercentage(
                  data?.year_wise[0]?.[`totalWay2newsRevenue_${data?.year_wise[0]?.year -1}`] /
                  data?.year_wise[0]?.[`totalWay2newsInsertions_${data?.year_wise[0]?.year-1}`] || 0,
                  data?.year_wise[0]?.[`totalWay2newsRevenue_${data?.year_wise[0]?.year}`] /
                  data?.year_wise[0]?.[`totalWay2newsInsertions_${data?.year_wise[0]?.year}`] || 0
                )}
              </td>
            </tr>
            <tr>
              <th colSpan={4}>W2N-Category Wise</th>
            </tr>
            {data?.category_wise?.map((item, index) => {
              const record = getRecord(item.category)[0];
              if (item.category === null) return null;
              return (
                <>
                  <tr key={`${item.category}_${index}`}>
                    <th colSpan={4}>{item.category}</th>
                  </tr>
                  <tr>
                    <td>Accounts Advertised</td>
                    <td>{record[`totalWay2newsBrandCount_${data?.year_wise[0]?.year -1}`]}</td>
                    <td>{record[`totalWay2newsBrandCount_${data?.year_wise[0]?.year}`]}</td>
                    <td>
                      {calculatePercentage(
                        record[`totalWay2newsBrandCount_${data?.year_wise[0]?.year -1}`],
                        record[`totalWay2newsBrandCount_${data?.year_wise[0]?.year}`]
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>No of Insertions</td>
                    <td>{record[`totalWay2newsInsertions_${data?.year_wise[0]?.year-1}`]}</td>
                    <td>{record[`totalWay2newsInsertions_${data?.year_wise[0]?.year}`]}</td>
                    <td>
                      {calculatePercentage(
                        record[`totalWay2newsInsertions_${data?.year_wise[0]?.year-1}`],
                        record[`totalWay2newsInsertions_${data?.year_wise[0]?.year}`]
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Revenues</td>
                    <td>{toLakhs(record[`totalWay2newsRevenue_${data?.year_wise[0]?.year -1}`]) }</td>
                    <td>{toLakhs(record[`totalWay2newsRevenue_${data?.year_wise[0]?.year}`])}</td>
                    <td>
                      {calculatePercentage(
                        record[`totalWay2newsRevenue_${data?.year_wise[0]?.year -1}`],
                        record[`totalWay2newsRevenue_${data?.year_wise[0]?.year}`]
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Revenue per Insertion</td>
                    <td>
                      {record[`totalWay2newsInsertions_${data?.year_wise[0]?.year-1}`] ? toLakhs(
                        record[`totalWay2newsRevenue_${data?.year_wise[0]?.year -1}`] /
                        record[`totalWay2newsInsertions_${data?.year_wise[0]?.year-1}`] || 0
                      ): 0}
                    </td>
                    <td>
                      {record[`totalWay2newsInsertions_${data?.year_wise[0]?.year}`] ?  toLakhs(
                        record[`totalWay2newsRevenue_${data?.year_wise[0]?.year}`] /
                        record[`totalWay2newsInsertions_${data?.year_wise[0]?.year}`]  || 0
                      ) : 0}
                    </td>
                    <td>
                      {calculatePercentage(
                        record[`totalWay2newsRevenue_${data?.year_wise[0]?.year -1}`] /
                        record[`totalWay2newsInsertions_${data?.year_wise[0]?.year-1}`]  || 0,
                        record[`totalWay2newsRevenue_${data?.year_wise[0]?.year}`] /
                        record[`totalWay2newsInsertions_${data?.year_wise[0]?.year}`] || 0
                      )}
                    </td>
                  </tr>
                </>
              );
            })}
          </tbody>
        ) : loader ? (
          <TableLoader colspan={4} />
        ) : (
          <NoDataFound colspan={4} />
        )}
      </table>
      </ScrollContainer>
    </>
  );
}

export default PlanSummary;
